import { fetcher } from 'redux/apisMember';
import { Organization, EntityList } from 'types';
import makeGetHook from '@eGroupTeam/hooks/makeGetHook';

const useOrgs = makeGetHook<EntityList<Organization>>(
  '/organizations',
  fetcher
);
export default useOrgs;
